module.exports = (function() {
    'use strict';
    var validatorUtils = require('../utils/validator.utils');
    const logger = require('od-modules/utils/logger');
    const Fetcher = require('od-modules/utils/fetcher');
    const tagManagement = require('../utils/tag_management.utils');
    const SUBSCRIBE_URL = '/travel/service/subscriptions/subscriptionFDO/subscribe';
    return Odigeo.Model.extend({
        defaultPassengers: {
            adults: {},
            children: {},
            infants: {},
            defaultTraveler: null,
        },
        initialPassengers: {},
        passengerID: null,
        validationTypes: {
            REGEX_VALIDATOR: 'REGEX_VALIDATOR',
            NULL_VALIDATOR: 'NULL_VALIDATOR',
            OPTIONAL: 'OPTIONAL',
            SECOND_EMAIL_VALIDATOR: 'SECOND_EMAIL_VALIDATOR',
            IDENTIFICATION_VALIDATOR_NIF: 'IDENTIFICATION_VALIDATOR_NIF',
            IDENTIFICATION_VALIDATOR_NIE: 'IDENTIFICATION_VALIDATOR_NIE',
            IDENTIFICATION_VALIDATOR_CIF: 'IDENTIFICATION_VALIDATOR_CIF',
            IDENTIFICATION_VALIDATOR_PASSPORT: 'IDENTIFICATION_VALIDATOR_PASSPORT',
            IDENTIFICATION_VALIDATOR_NATIONAL_ID_CARD: 'IDENTIFICATION_VALIDATOR_NATIONAL_ID_CARD',
            REQUIRED_STRING: 'REQUIRED_STRING',
            EXPIRATION_DATE: 'EXPIRATION_DATE',
            ADULT_DATE_OF_BIRTH: 'ADULT_DATE_OF_BIRTH',
            INFANT_DATE_OF_BIRTH: 'INFANT_DATE_OF_BIRTH',
            CHILD_DATE_OF_BIRTH: 'CHILD_DATE_OF_BIRTH',
            ZIP_CODE_VALIDATOR: 'ZIP_CODE_VALIDATOR',
            INFANT_MAX_AGE: 2,
            CHILD_MAX_AGE: 12,
            CHILD_MIN_AGE: 2,
            ADULT_MIN_AGE: 12,
            CPF_VALIDATOR: 'CPF_VALIDATOR',
            SECOND_EMAIL_VALIDATOR_CASE_INSENSITIVE: 'SECOND_EMAIL_VALIDATOR_CASE_INSENSITIVE',
        },
        custom_email: '',
        travellerModel: require('../data/traveller'),
        user: null,
        passengerSelectedId: -1,
        passengerType: '',
        firstPassengerTemp: {},
        discountSelected: false,

        connect: true,
        silentChange: false,
        selectors: ['frequentFlyerShowed', 'residentDiscountApplied'],
        /**
         * Initializes the model
         */
        init: function() {
            this.widget.options = Odigeo.parseOptions(this.widget.options);
        },

        onStoreChange() {
            if (this.get('frequentFlyerShowed') && !this.widget.options.isBuyer) {
                Odigeo.trigger(this.widget.name + ':frequentFlyerShown');
            }
        },

        url: function() {
            return Odigeo.Settings.getProperty('geoServiceUrlFormatter')('geolocateIp');
        },

        crmSubscribeCustomerEmail(email) {
            if (email !== this.widget.model.custom_email) {
                this.widget.model.custom_email = email;
                Fetcher.post(SUBSCRIBE_URL, {
                    email,
                }).json();
                tagManagement.fireEvent('submit_form', 'customer_email', email);
            }
        },

        getInitialPassengers: function() {
            var type = this.widget.options.travellerType;
            var storageTravellers = true;
            var initial = [];

            Odigeo._.each(this.widget.model.readAllPassengers(storageTravellers)[type], function(pass, id) {
                initial.push({
                    id: id,
                    name: [pass.name, pass.firstLastName || pass.lastName].join(' ').trim(),
                });
            });

            this.initialPassengers = initial;
        },

        /**
         * Retrieves the given passenger from sessionStorage or localStorage
         * @param {object} passengerID
         * @return {object} passenger - The passenger retrieved
         */
        readPassenger: function(passengerID) {
            var allPassengers = this.readAllPassengers()[this.widget.options.travellerType];

            if (Odigeo._.has(allPassengers, passengerID)) {
                return allPassengers[passengerID];
            } else {
                return null;
            }
        },

        readAllPassengers: function(fromLocalStorage) {
            var travellers;
            var allPassengers = Odigeo._.clone(this.defaultPassengers);

            try {
                travellers = (fromLocalStorage && Odigeo.Storage.get('travellers')) || null;
                if (!Odigeo._.isNull(travellers)) {
                    allPassengers = JSON.parse(travellers);
                }
            } catch (error) {
                logger.error(error, 'Passengers could not be retrieved.');
            }

            return allPassengers;
        },

        resetCacheBaggages: function() {
            var passType = [this.widget.options.travellerType];
            var storageTravellers = true;
            var storedPassengers = this.readAllPassengers(storageTravellers) || {};
            if (!Odigeo._.isEmpty(storedPassengers)) {
                Odigeo._.each(storedPassengers[passType], function(passenger) {
                    if (!Odigeo._.isUndefined(passenger.baggageSelectionDTOs) || !Odigeo._.isEmpty(passenger.baggageSelectionDTOs)) {
                        passenger.baggageSelectionDTOs = [];
                    }
                }, this);
            }
        },

        validateNIF: Odigeo.Utils.isValidNif,

        validateNIE: function(nie) {
            var lockup = 'XYZ';
            var pos = lockup.indexOf(nie.substr(0, 1).toUpperCase());
            if (pos >= 0) {
                return Odigeo.Utils.isValidNif(pos + nie.substr(1));
            }
            return false;
        },

        checkMailValidity: function(valData, value) {
            var pattern = new RegExp(valData.pattern);
            return pattern.test(value);
        },
        /**
         * Checks if the provided string is a valid passport value.
         * As stated in "SYRTOF-1866", a passport value is valid if it has no more than 20 chars.
         * @param {String} value The passport value to be checked.
         * @return {boolean} True if the specified text is a valid passport value, false otherwise.
         * @private
         */
        _validatePassport: function(value) {
            return !!value && value.length <= 20;
        },

        _uniqueIdDocument: function(idNumber) {
            var $passengers = $('[data-id^="passengers"]').find('input[name="identification"]');
            var idDocOccurences = Odigeo._.reduce($passengers, function(memo, elem) {
                if (idNumber.toUpperCase() === $(elem).val().toUpperCase()) {
                    ++memo;
                }
                return memo;
            }, 0);

            return idDocOccurences === 1;
        },

        _validateUniqueFields: function($el) {
            var $uniqueFields = $el.closest('[data-viewwidget]').find('[data-id^="passenger"] [name="' + $el.data('name') + '"]');
            var fieldValues = Odigeo._.compact(Odigeo._.map($uniqueFields, 'value'));

            return Odigeo._.uniq(fieldValues).length === fieldValues.length;
        },

        checkValidity: function($input, autoFilled) {
            const validPattern = (stringPattern, val) => new RegExp(stringPattern).test(val);
            const checkPattern = (stringPattern, val) => this.widget.options.isIdValidCharacters
                ? validPattern(stringPattern, val)
                : true;
            var valData = $input.data();
            var value = $input.val();
            var expDate;
            var pattern;
            var bday;
            var maxDate;
            var minDate;
            var lastFlight = new Date(Number(this.widget.options.lastDepartureDate || Date.now())).getTime();
            var now = new Date();
            var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
            var validity;
            var emptiness = Odigeo._.isEmpty(value);
            var required = $input.attr('required') === 'required';
            var uniqueness = true;

            switch ($input.data('validationType')) {
                case this.validationTypes.REGEX_VALIDATOR:
                    pattern = new RegExp(valData.pattern);
                    validity = pattern.test(value);
                    break;
                case this.validationTypes.IDENTIFICATION_VALIDATOR_NIF:
                    pattern = new RegExp(valData.pattern);
                    validity = pattern.test(value) && this.validateNIF(value);
                    if (!this.widget.options.isBuyer) {
                        validity = validity && this._uniqueIdDocument(value);
                    }
                    break;
                case this.validationTypes.OPTIONAL:
                    validity = true;
                    break;
                case this.validationTypes.IDENTIFICATION_VALIDATOR_NIE:
                    pattern = new RegExp(valData.pattern);
                    validity = pattern.test(value) && this.validateNIE(value);
                    if (!this.widget.options.isBuyer) {
                        validity = validity && this._uniqueIdDocument(value);
                    }
                    break;
                case this.validationTypes.IDENTIFICATION_VALIDATOR_NATIONAL_ID_CARD:
                    validity = (!required || !!value) && checkPattern(valData.pattern, value);
                    break;
                case this.validationTypes.IDENTIFICATION_VALIDATOR_CIF:
                    validity = !!value && checkPattern(valData.pattern, value);
                    break;
                case this.validationTypes.IDENTIFICATION_VALIDATOR_PASSPORT:
                    validity = this._validatePassport(value) && checkPattern(valData.pattern, value);
                    break;
                case this.validationTypes.NULL_VALIDATOR:
                    validity = !required || !!value;
                    break;
                case this.validationTypes.REQUIRED_STRING:
                    validity = Odigeo._.isString(value) && !!value;
                    break;
                case this.validationTypes.SECOND_EMAIL_VALIDATOR:
                case this.validationTypes.SECOND_EMAIL_VALIDATOR_CASE_INSENSITIVE:
                    var buyerEmailValue = this.widget.view.$cachedSelectors.buyerEmail.val();
                    if (buyerEmailValue) {
                        value = value.toLowerCase();
                        buyerEmailValue = buyerEmailValue.toLowerCase();
                    }
                    validity = !!value && this.checkMailValidity(valData, value) &&
                        (value === buyerEmailValue);
                    break;
                case this.validationTypes.EXPIRATION_DATE:
                    expDate = new Date(value.replace(/-/g, '/'));
                    // Check for invalid date
                    if (isNaN(expDate.getTime())) {
                        validity = false;
                    } else {
                        validity = expDate > lastFlight;
                    }
                    break;
                case this.validationTypes.ADULT_DATE_OF_BIRTH:
                    bday = new Date(value.replace(/-/g, '/'));
                    // Check for invalid date
                    if (isNaN(bday.getTime())) {
                        validity = false;
                    } else {
                        minDate = new Date(bday.getFullYear() + this.validationTypes.ADULT_MIN_AGE, bday.getMonth(), bday.getDate());
                        validity = lastFlight >= minDate && bday < today;
                    }
                    break;
                case this.validationTypes.CHILD_DATE_OF_BIRTH:
                    bday = new Date(value.replace(/-/g, '/'));
                    // Check for invalid date
                    if (isNaN(bday.getTime())) {
                        validity = false;
                    } else {
                        minDate = new Date(bday.getFullYear() + this.validationTypes.CHILD_MIN_AGE, bday.getMonth(), bday.getDate());
                        maxDate = new Date(bday.getFullYear() + this.validationTypes.CHILD_MAX_AGE, bday.getMonth(), bday.getDate());
                        validity = lastFlight >= minDate && lastFlight < maxDate;

                        // Alert the handler for specific behavior
                        if (!validity) {
                            Odigeo.trigger(this.widget.name + ':ageValidationFailed', 'kid', autoFilled);
                        }
                    }
                    break;
                case this.validationTypes.INFANT_DATE_OF_BIRTH:
                    bday = new Date(value.replace(/-/g, '/'));
                    // Check for invalid date
                    if (isNaN(bday.getTime())) {
                        validity = false;
                    } else {
                        maxDate = new Date(bday.getFullYear() + this.validationTypes.INFANT_MAX_AGE, bday.getMonth(), bday.getDate());
                        validity = lastFlight < maxDate && bday < today;

                        // Alert the handler for specific behavior
                        if (!validity) {
                            Odigeo.trigger(this.widget.name + ':ageValidationFailed', 'kid', autoFilled);
                        }
                    }
                    break;
                case this.validationTypes.ZIP_CODE_VALIDATOR:
                    var countryCode = this.widget.view.$cachedSelectors.buyerCountry.val();
                    validity = Odigeo.Utils.isValidPostalCode(countryCode, value.toUpperCase());
                    break;
                case this.validationTypes.CPF_VALIDATOR:
                    var cpfFix = $input.val();
                    validity = validatorUtils.isValidCpf(cpfFix);
                    break;
                default:
                    return value;
            }

            if (!Odigeo._.isUndefined(valData.unique)) {
                uniqueness = this._validateUniqueFields($input);
            }

            if (Odigeo.AB.removeConfirmEmailEnabled && $input.data('name') === 'mail') {
                this.widget.view.showHideConfirmEmailText(validity);
            }

            return uniqueness && !emptiness ? validity : undefined;
        },

        getLatestPossibleBirthDate: function() {
            var latestDate = new Date(Number(this.widget.options.lastDepartureDate || Date.now()));
            switch (this.widget.options.travellerType) {
                case this.widget.passengerTypes.ADULT:
                    latestDate.setFullYear(latestDate.getFullYear() - this.validationTypes.ADULT_MIN_AGE);
                    break;
                case this.widget.passengerTypes.CHILD:
                    latestDate.setFullYear(latestDate.getFullYear() - this.validationTypes.CHILD_MIN_AGE);
                    break;
                case this.widget.passengerTypes.INFANT:
                    latestDate = new Date(Date.now());
                    latestDate.setDate(latestDate.getDate() - 1);
                    break;
            }
            return latestDate;
        },

        getEarliestPossibleBirthDate: function() {
            var earliestDate = new Date(Number(this.widget.options.lastDepartureDate || Date.now()));

            switch (this.widget.options.travellerType) {
                case this.widget.passengerTypes.ADULT:
                    earliestDate.setFullYear(1900);
                    break;
                case this.widget.passengerTypes.CHILD:
                    earliestDate.setFullYear(earliestDate.getFullYear() - this.validationTypes.CHILD_MAX_AGE);
                    break;
                case this.widget.passengerTypes.INFANT:
                    earliestDate.setFullYear(earliestDate.getFullYear() - this.validationTypes.INFANT_MAX_AGE);
                    break;
            }
            earliestDate.setDate(earliestDate.getDate() + 1);
            return earliestDate;
        },
    });
}());
